import { createContext, useContext } from 'react';

import type { ReactNode } from 'react';

export type GlobalSearchSlotProps = {
  /** Shows the search disabled, with a stated reason, on a page it cannot serve yet. */
  disabled: boolean;
};

type RenderSearch = (props: GlobalSearchSlotProps) => ReactNode;

const GlobalSearchSlotContext = createContext<RenderSearch | null>(null);

/**
 * Hands the header the global search. The search knows devices, workflows and plans, which
 * `shared/` may not import, so `app/` provides it here and `GlobalActions` renders whatever it is
 * given: nothing, when no provider is mounted.
 */
export function GlobalSearchSlotProvider({
  renderSearch,
  children,
}: {
  /** Keep it module-level: a new function every render re-renders every header. */
  renderSearch: RenderSearch;
  children: ReactNode;
}) {
  return (
    <GlobalSearchSlotContext.Provider value={renderSearch}>
      {children}
    </GlobalSearchSlotContext.Provider>
  );
}

export function useGlobalSearchSlot() {
  return useContext(GlobalSearchSlotContext);
}
